import Vue from 'vue'
import Router from 'vue-router'
//登录页
import login from '@/components/login'

import manager from '@/components/manager'

import addKj from '@/components/index/addKj'
import editDances from '@/components/index/editDances'

//首页
import centersCon from '@/components/centersCon'
import CateManage from '@/components/index/CateManage'
//期数
import singleLesson from '@/components/index/singleLesson'
import makTep from '@/components/index/makTep'
import templet1 from '@/components/index/temlp/templet1'
import startFrom from '@/components/index/makFrom/startFrom'
import newPeriods from '@/components/index/newPeriods'
import formDate from '@/components/index/makFrom/formDate'
//素材管理
import material from '@/components/material/material'
//用户管理
import user from '@/components/user/user'
//权限管理
import auth from '@/components/auth/auth'

//数据中心
import dataCount from '@/components/data/dataCount'
//承办单位管理
import company from '@/components/company/company'
import oldclass from '@/components/company/oldclass'
import teacherClass from '@/components/company/teacherClass'
//师资
import teaClass from '@/view/teacher/class'
import work from '@/view/teacher/work'
import workDeail from '@/view/teacher/workDeail'
import teaBan from '@/view/teacher/ban'
import teaTui from '@/view/teacher/tui'
import stulist from '@/view/teacher/stulist'
//用户
import userTea from '@/components/user_mager/tea'
import userStu from '@/components/user_mager/stu'
import zs from '@/components/user_mager/zs'
import userStuList from '@/components/user_mager/stuList'
//课件
import Class from '@/components/stu_class/class'
//订单 财务
import Order from '@/components/finance/order'
import Finance from '@/components/finance/finance'
import Accounts from '@/components/finance/accounts'
//账号
import Admin from '@/components/admin/admin'
//配置
import Pindex from '@/components/peizhi/index'
import newNotice from '@/components/peizhi/newNotice'
import newsList from '@/components/peizhi/newsList'
import rizhi from '@/components/peizhi/rizhi'
import updateLog from '@/components/peizhi/updateLog'
import newLog from '@/components/peizhi/newLog'
//教演结合
import performIndex from '@/view/perform/index'
import performStu from '@/view/perform/stulist'
//学生考级管理
import studentExamIndex from '@/view/student_exam/index'
import studentExamStu from '@/view/student_exam/stulist'
//展演管理
import performanceIndex from '@/view/performance/index'
import performanceStu from '@/view/performance/stulist'
import performanceList from '@/view/performance/programlist'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    /*mode : 'history',
    base: '/admin/',*/
    routes: [{
            path: '/',
            redirect: '/login',
        },

        {
            path: "/login",
            component: login
        },
        {
            path: '/addCategory/index/temlp/templet1/:name',
            name: 'templet',
            component: templet1,
        },
        {
            path: '/perform',
            component: manager,
            children: [{
                    path: '/index',
                    redirect: '/perform/index'
                },
                {
                    path: '/perform/index',
                    component: performIndex,
                },
                {
                    path: '/perform/index/stulist',
                    component: performStu,
                },
            ]
        },
        {
            path: '/stuexam',
            component: manager,
            children: [{
                    path: '/index',
                    redirect: '/stuexam/index'
                },
                {
                    path: '/stuexam/index',
                    component: studentExamIndex,
                },
                {
                    path: '/stuexam/index/stulist',
                    component: studentExamStu,
                },
            ]
        },
        {
            path: '/performance',
            component: manager,
            children: [{
                    path: '/index',
                    redirect: '/performance/index'
                },
                {
                    path: '/performance/index',
                    component: performanceIndex,
                },
                {
                    path: '/performance/index/programList',
                    component: performanceList,
                },
                {
                    path: '/performance/index/stulist',
                    component: performanceStu,
                },
            ]
        },

        {
            path: '/manager',
            component: manager,
            children: [{
                    path: '/manager',
                    redirect: '/manager/company/company'
                },
                {
                    path: '/manager/data/dataCount',
                    component: dataCount,
                },
                {
                    path: '/manager/company/company',
                    component: company,
                },
                {
                    path: '/manager/company/company/oldclass',
                    component: oldclass,
                },
                {
                    path: '/manager/company/company/teacherClass',
                    component: teacherClass,
                },
                {
                    path: '/manager/teacher/class',
                    component: teaClass,
                },
                {
                    path: '/manager/teacher/work',
                    component: work,
                },
                {
                    path: '/manager/teacher/work/workDeail',
                    component: workDeail,
                },
                {
                    path: '/manager/teacher/class/ban',
                    component: teaBan,
                },
                {
                    path: '/manager/teacher/class/ban/stulist',
                    component: stulist,
                },
                {
                    path: '/manager/teacher/tui',
                    component: teaTui,
                },
                {
                    path: '/manager/user_mager/tea',
                    component: userTea,
                },
                {
                    path: '/manager/user_mager/stu',
                    component: userStu,
                },
                {
                    path: '/manager/user_mager/zs',
                    component: zs,
                },
                {
                    path: '/manager/user_mager/stu/stuList',
                    component: userStuList,
                },
                {
                    path: '/manager/stu_class/class',
                    component: Class,
                },
                {
                    path: '/manager/finance/order',
                    component: Order,
                },
                {
                    path: '/manager/finance/finance',
                    component: Finance,
                },
                {
                    path: '/manager/finance/accounts',
                    component: Accounts,
                },
                {
                    path: '/manager/peizhi/index',
                    component: Pindex,
                },
                {
                    path: '/manager/peizhi/newsList',
                    component: newsList,
                },
                {
                    path: '/manager/peizhi/rizhi',
                    component: rizhi,
                },
                {
                    path: '/manager/peizhi/updateLog',
                    component: updateLog,
                },
                {
                    path: '/manager/peizhi/updateLog/newLog',
                    component: newLog,
                },
                {
                    path: '/manager/peizhi/newsList/newNotice',
                    component: newNotice,
                },
                {
                    path: '/manager/admin/admin',
                    component: Admin,
                },
                //期数
                {
                    path: '/manager/stu_class/class/singleLesson',
                    // name:'singleLesson',
                    component: singleLesson
                },
                {
                    path: '/manager/stu_class/class/singleLesson/addKj',
                    // name:'addKj',
                    component: addKj
                },
                {
                    path: '/manager/stu_class/class/singleLesson/addKj/makTep',
                    name: 'makTep',
                    component: makTep,
                },
                {
                    path: '/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
                    component: startFrom,
                    name: 'wz'
                },
                {
                    path: '/manager/addCategory/centersCon',
                    name: 'centersCon',
                    component: centersCon,
                    children: [{
                        path: "/manager/addCategory/centersCon/newPeriods",
                        component: newPeriods,
                        name: 'newPeriods'
                    }]
                },
                {
                    path: '/manager/addCategory/centersCon/index/CateManage',
                    component: CateManage
                },

                {
                    path: '/manager/addCategory/centersCon/index/makFrom/formDate',
                    component: formDate,
                    name: 'formDate'
                },


                //素材管理
                {
                    path: '/manager/material',
                    component: material
                },

                //用户管理
                {
                    path: '/manager/user',
                    component: user,
                    name: 'user'
                },

                //权限管理
                {
                    path: '/manager/auth',
                    component: auth,
                    name: 'auth'
                },
            ]
        },


    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js